import { ICatalogue } from "../../apis/useGetCatalogueData/types";
import { IItemLimitPerPax } from "../../contexts/ConfigContext/types";

const DEFAULT_PAX = 1;

const countRestrictedItems = (cart: ICatalogue[], group: IItemLimitPerPax): number =>
	cart.reduce((sum, item) => {
		if (!item.food_supplier_category?.item_order_restriction) return sum;
		if (!group.categories.includes(item.food_supplier_category.brand_category_id)) return sum;

		return sum + item.quantity;
	}, 0);

export const isItemOrderLimitExceeded = (
	itemToAdd: ICatalogue,
	cart: ICatalogue[],
	itemLimitPerPax: IItemLimitPerPax[] | undefined,
	pax: number
): boolean => {
	if (!itemLimitPerPax?.length) return false;
	if (!itemToAdd.food_supplier_category?.item_order_restriction) return false;

	const brandCategoryId = itemToAdd.food_supplier_category.brand_category_id;
	const limitGroup = itemLimitPerPax.find((group) => group.categories.includes(brandCategoryId));

	if (!limitGroup) return false;

	const effectivePax = pax > 0 ? pax : DEFAULT_PAX;
	const limit = limitGroup.max * effectivePax;

	return countRestrictedItems(cart, limitGroup) + itemToAdd.quantity > limit;
};

export const isCartItemLimitExceeded = (
	cart: ICatalogue[],
	itemLimitPerPax: IItemLimitPerPax[] | undefined,
	pax: number
): boolean => {
	if (!itemLimitPerPax?.length) return false;

	const effectivePax = pax > 0 ? pax : DEFAULT_PAX;

	return itemLimitPerPax.some(
		(group) => countRestrictedItems(cart, group) > group.max * effectivePax
	);
};
